<div class="shared-main-banner">
  <div class="shared-main-banner__description">
    <h1 class="shared-main-banner__description__heading">
      {{ translationPrefix + 'banner.heading' | translate }}
    </h1>
    <div class="subheading">
      {{ translationPrefix + 'banner.subheading' | translate }}
    </div>
  </div>
  <img src="assets/img/assets-logo.svg" />
</div>

<div class="upload-step">
  <app-upload-heading
    [translationPrefix]="translationPrefix + 'downloadTemplate'"
    [label]="'1'" />
  <div class="upload-step__content">
    <app-download-template [translationPrefix]="translationPrefix" />
  </div>
</div>

<div class="upload-step">
  <app-upload-heading
    [translationPrefix]="translationPrefix + 'importFile'"
    [label]="'2'" />
  <div class="upload-step__content">
    <app-import-file [translationPrefix]="translationPrefix + 'importFile.'" />
  </div>
</div>

<app-faq [translationPrefix]="translationPrefix + 'faq.'"></app-faq>
